export const MOBILE_NAV_MENU_TYPE = {
  EXT_LINK: "external-link",
  VERIFIED_BADGE: "verified-badge",
  PENDING_BADGE: "pending-badge",
};
